
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Punetomumbaiairportinnova() {



    const cardData =
    {
        keyword: 'Pune to Mumbai Airport Innova Services',
        heading: 'S9 Travels: Pune to Mumbai Airport Innova Services',
        headingDescription: 'S9 Travels offers comfortable and reliable Innova taxi services from Pune to Mumbai Airport. Whether you’re traveling for business, a family vacation, or any other reason, our well-maintained fleet of Innovas ensures a smooth, safe, and enjoyable ride. The journey from Pune to Mumbai Airport is approximately 150 km and typically takes around 3 to 3.5 hours by road. With professional drivers, comfortable seating, and top-notch customer service, we ensure your trip is hassle-free from start to finish.',

        top: 'Top Places to Visit in Mumbai with S9 Travels',

"topPlaces": [
    {
      "title": "Gateway of India",
      "description": "The Gateway of India is an iconic symbol of Mumbai. This majestic archway was built to commemorate the visit of King George V and Queen Mary in 1911. Located on the waterfront, it’s a perfect spot for photography and to take in the beautiful views of the Arabian Sea."
    },
    {
      "title": "Marine Drive",
      "description": "Marine Drive, also known as the Queen's Necklace, is a stunning boulevard that stretches along the coastline. It’s famous for its beautiful sunset views and is a popular place for an evening stroll, offering a great vantage point of the city's skyline."
    },
    {
      "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
      "description": "This UNESCO World Heritage Site is one of Mumbai's most famous landmarks. Known for its Victorian Gothic architectural style, CST is a historic railway station and a must-visit for history and architecture enthusiasts."
    },
    {
      "title": "Elephanta Caves",
      "description": "A short ferry ride from the city takes you to Elephanta Island, where you can explore ancient rock-cut caves with stunning sculptures dedicated to Lord Shiva. The caves are a UNESCO World Heritage Site and offer a blend of art, history, and natural beauty."
    },
    {
      "title": "Colaba Causeway",
      "description": "Colaba Causeway is a vibrant shopping street where you can find everything from clothes, jewelry, and antiques to local handicrafts. It’s also home to a range of cafes and restaurants, making it a popular spot for tourists and locals alike."
    },
    {
      "title": "Bandra-Worli Sea Link",
      "description": "This stunning bridge is an engineering marvel and offers panoramic views of the Arabian Sea and Mumbai’s skyline. A drive across the Bandra-Worli Sea Link is an unforgettable experience, especially during the evening when the bridge is beautifully lit."
    },
    {
      "title": "Juhu Beach",
      "description": "Juhu Beach is one of Mumbai’s most famous beaches, popular for its relaxed atmosphere, food stalls, and lively crowds. It’s the perfect spot to enjoy a beach day, watch the sunset, or savor local street food like pav bhaji and bhel puri."
    },
    {
      "title": "Haji Ali Dargah",
      "description": "The Haji Ali Dargah is a beautiful mosque and tomb located on an islet in the Arabian Sea. This iconic structure is both a spiritual and architectural marvel, offering a serene and peaceful experience for visitors."
    },
    {
      "title": "Sanjay Gandhi National Park",
      "description": "Escape the hustle and bustle of Mumbai and visit Sanjay Gandhi National Park, located on the outskirts of the city. The park offers a green oasis with walking trails, a lake, and the famous Kanheri Caves, providing an ideal retreat for nature lovers."
    },
    {
      "title": "Chor Bazaar",
      "description": "Known as the 'Thieves Market,' Chor Bazaar is a bustling street market in the heart of Mumbai. It’s the place to go if you’re looking for vintage items, antiques, or unique collectibles at bargain prices."
    }
],

"services": [
    {
      "name": "Book Pune to Mumbai Airport Innova Cab",
      "description": "Travel in comfort with an Innova cab from Pune to Mumbai Airport. Whether you have a flight to catch or are returning from a trip, our Innova taxis offer a comfortable and luxurious ride, ensuring a smooth journey to and from the airport."
    },
    {
      "name": "Pune to Mumbai Airport Innova Car Hire",
      "description": "Need a reliable vehicle for your airport trip? Hire an Innova car for your Pune to Mumbai Airport journey. Our Innova rentals offer flexibility, comfort, and plenty of space for luggage, making it ideal for your airport transfers."
    },
    {
      "name": "Pune to Mumbai Airport Taxi Service",
      "description": "Book a hassle-free taxi service from Pune to Mumbai Airport. Our professional drivers and well-maintained Innova cabs ensure timely arrivals, making your travel experience pleasant and stress-free."
    },
    {
      "name": "Pune to Mumbai Airport One-Way Innova",
      "description": "If you are traveling one-way to Mumbai Airport from Pune, book an Innova one-way taxi. It’s a perfect option for travelers who prefer a direct, comfortable ride without worrying about return details."
    },
    {
      "name": "Pune to Mumbai Airport Round Trip Innova",
      "description": "For those who need a round-trip taxi to Mumbai Airport, our Innova cabs offer a great option. Book a round trip to ensure you have a reliable vehicle both ways. Our round-trip service includes pick-up from Pune, a safe journey to the airport, and a return trip after your flight."
    },
    {
      "name": "Mumbai Airport to Pune Innova",
      "description": "After your arrival at Mumbai Airport, book an Innova taxi for a comfortable ride back to Pune. Our drivers will track your flight’s schedule and ensure that you’re picked up promptly, even in case of delays."
    },
    {
      "name": "Mumbai Airport Innova Taxi Booking",
      "description": "Looking to book an Innova taxi to or from Mumbai Airport? Our online Innova booking service lets you choose from different packages—one-way, round-trip, or even hourly rentals for any trip related to Mumbai Airport."
    },
    {
      "name": "Affordable Pune to Mumbai Airport Innova",
      "description": "Travel affordably with an Innova taxi from Pune to Mumbai Airport. We offer competitive prices without compromising on comfort. Whether it’s a solo trip or with family, our affordable Innova taxis ensure great value for money."
    },
    {
      "name": "Mumbai to Pune Innova Cab",
      "description": "For travelers heading back to Pune from Mumbai Airport, our Innova cabs provide a comfortable and spacious ride. Book your Mumbai to Pune Innova cab and enjoy a smooth, enjoyable ride after your flight."
    },
    {
      "name": "Luxury Innova for Mumbai Airport",
      "description": "For those looking for a luxury ride to Mumbai Airport, our luxury Innova cabs offer premium features such as plush seating, air conditioning, and a smooth ride for a top-tier travel experience. Perfect for business travelers or those looking for extra comfort."
    },
    {
      "name": "Mumbai to Pune One-Way Innova",
      "description": "If you're flying into Mumbai Airport and need a one-way ride to Pune, our Innova one-way cab service provides a convenient, comfortable, and cost-effective way to travel. Sit back and relax while we take you to your destination."
    },
    {
      "name": "Private Innova Cab from Pune to Mumbai Airport",
      "description": "Book a private Innova cab for your Pune to Mumbai Airport trip. Whether you’re traveling alone, with family, or in a group, having a private vehicle ensures that you can travel in privacy and comfort."
    },
    {
      "name": "Group Travel to Mumbai Airport by Innova",
      "description": "Traveling with a group? Our Innova cabs are ideal for group travel to Mumbai Airport. With ample space for luggage and passengers, everyone can travel together in comfort. Book a group travel Innova for a smooth and enjoyable airport trip."
    },
    {
      "name": "Book Innova for Mumbai Airport Pickup",
      "description": "Need a pick-up from Mumbai Airport? Book an Innova for Mumbai Airport pickup and our driver will be waiting for you at the airport with a nameboard, ready to take you to Pune or any other destination."
    }
  ],

"tableData": [
  ["Book Pune to Mumbai Airport Innova Cab", "Pune to Mumbai Airport Innova Car Hire"],
  ["Pune to Mumbai Airport Taxi Service", "Pune to Mumbai Airport One-Way Innova"],
  ["Pune to Mumbai Airport Round Trip Innova", "Mumbai Airport to Pune Innova"],
  ["Mumbai Airport Innova Taxi Booking", "Affordable Pune to Mumbai Airport Innova"],
  ["Mumbai to Pune Innova Cab", "Luxury Innova for Mumbai Airport"],
  ["Mumbai to Pune One-Way Innova", "Private Innova Cab from Pune to Mumbai Airport"],
  ["Group Travel to Mumbai Airport by Innova", "Book Innova for Mumbai Airport Pickup"],
  ["", ""]
],
"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we understand how important it is to catch your flight on time. We ensure prompt pickups from your location in Pune and a smooth drive to Mumbai Airport. Our drivers are punctual and committed to making sure you reach the airport well in advance for your flight."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "The Toyota Innova is perfect for long journeys like Pune to Mumbai Airport. With comfortable seating, air conditioning, and ample space for luggage, our Innova cabs provide a relaxing and stress-free travel experience. Whether you’re traveling alone or with family or friends, you’ll enjoy a comfortable ride."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are experienced and well-versed with the best routes from Pune to Mumbai Airport. They are punctual, courteous, and knowledgeable, ensuring a smooth and hassle-free journey. We prioritize your comfort and safety, so you can relax during your trip."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive and transparent pricing for your Pune to Mumbai Airport Innova booking. You’ll receive a clear breakdown of all costs before confirming your booking, with no hidden charges, allowing you to plan your travel comfortably."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Safety is our priority. Our Toyota Innova vehicles are equipped with modern safety features like airbags, seat belts, and GPS tracking. We make sure you enjoy a secure and comfortable ride throughout the journey to Mumbai Airport."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "No matter what time your flight is, S9 Travels is available 24/7. Whether you have an early morning flight or a late-night arrival, we will ensure that your ride is ready when you need it. Our customer service team is also available around the clock to assist you with your bookings."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking your Pune to Mumbai Airport Innova cab is simple and convenient with S9 Travels. You can book online through our website or mobile app, or you can contact our customer service team for personalized assistance in booking your cab."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "If you have specific requirements or need additional services for your journey, we offer customized travel packages. Whether it’s a direct drop to the airport or a stop for refreshments along the way, we tailor the trip to meet your needs."
  }
]





















    }



    const faqData = [
        [
          {
            question: 'How can I book an Innova cab for Pune to Mumbai Airport with S9 Travels?',
            answer: 'Booking is easy! You can book your Innova cab online via our website or mobile app, or you can reach out to our customer service team for personalized assistance.',
          },
          {
            question: 'What is the seating capacity of the Innova?',
            answer: 'The Toyota Innova comfortably accommodates up to 6 passengers, making it ideal for families, groups, or anyone with a lot of luggage.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel to Mumbai Airport?',
            answer: 'Yes, our drivers are highly experienced and familiar with the best routes to Mumbai Airport. They ensure a smooth, safe, and timely journey for all passengers.',
          },
          {
            question: 'What payment options are available for booking an Innova for Pune to Mumbai Airport?',
            answer: 'We offer flexible payment options, including cash, credit/debit cards, and online payments via our app, so you can pay easily and securely.',
          },
          {
            question: 'Can I book a round trip for Pune to Mumbai Airport?',
            answer: 'Yes, we can arrange for a round trip. Just provide your return details, and we’ll make sure your ride back to Pune is just as smooth and comfortable.',
          },
          {
            question: 'Are there any extra charges for waiting or detours during the trip?',
            answer: 'Any extra charges, such as waiting time or detours, will be communicated to you upfront, ensuring full transparency in the pricing structure.',
          },
          {
            question: 'Can I use the Innova for additional stops along the way?',
            answer: 'Yes, if you need to make additional stops or detours, please let us know during the booking process, and we will accommodate your requests.',
          },
          {
            question: 'What is the luggage allowance for an Innova cab?',
            answer: 'The Toyota Innova offers plenty of space for standard luggage. If you have more luggage or specific requirements, kindly inform us when booking, and we’ll make the necessary arrangements.',
          },
          {
            question: 'Is S9 Travels available for corporate travel to Mumbai Airport?',
            answer: 'Yes, we offer corporate travel services for individuals or groups traveling to Mumbai Airport. We ensure a professional, comfortable, and timely service.',
          },
          {
            question: 'Why should I choose S9 Travels for my Pune to Mumbai Airport Innova booking?',
            answer: 'S9 Travels provides a reliable, safe, and comfortable ride with professional drivers, well-maintained vehicles, and excellent customer service. We ensure your journey to Mumbai Airport is stress-free and enjoyable.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Ankit Desai',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked an Innova cab for my early morning flight to Mumbai Airport, and I couldn’t be happier with the service. The driver was on time, and the ride was smooth and comfortable. I highly recommend S9 Travels for anyone needing a ride to the airport!”',
        },
        {
          name: 'Mrs. Rekha Sharma',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our family used S9 Travels for a trip to Mumbai Airport, and the experience was great. The vehicle was clean, spacious, and comfortable, and the driver was professional. I’ll definitely book again for my next trip!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
      
      
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Mumbai Airport Innova",
        "description": "Book an Innova cab from Pune to Mumbai Airport with S9 Travels. Offering affordable and luxury Innova cabs for one-way and round trip, airport drop, pickup, and private travel to Mumbai Airport. Comfortable and reliable airport transfers in a premium Innova taxi.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.9",
          "ratingCount": "2500"
        }
      };
      
      
      


    return (
        <div>
         <Helmet>
        <title>Pune to Mumbai Airport Innova | Affordable & Luxury Innova Cabs for Airport Transfer | Book Now | S9 Travels</title>
        <meta 
          name="description" 
          content="Book an Innova cab from Pune to Mumbai Airport with S9 Travels. Offering comfortable one-way, round trip, and luxury Innova cabs for airport transfer, pickup, and drop-off services. Reliable and affordable airport taxi service to and from Mumbai Airport." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/36.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetomumbaiairportinnova;